import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b9ea9ea2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/unsuccessful-payment/unsuccessful-payment.scss?vue&type=style&index=0&id=b9ea9ea2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ea9ea2",
  null
  
)

export default component.exports